import { head } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import { useGroupsState, useUsersState } from '../_load/GroupsLoader'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'
import { useGroupsActionsList } from '../../../../utils/actions/groups/list'

const MultiRowsActions = () => {
  const { userGroups } = useGroupsState()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const selectedGroups = getSelectedData(userGroups)
  const menuOptions = useGroupsActionsList(head(selectedGroups), selecteds)

  return <MultiSelectMenu options={menuOptions} />
}

export default MultiRowsActions
